module.exports = __webpack_public_path__ + "media/images/thorrel-desc-2-124c1e4aa57b58e647720cae4e994959.png";